/** @jsx jsx */
import { jsx } from '@emotion/react';
import {Tab, Tabs} from "@blueprintjs/core";
// eslint-disable-next-line no-unused-vars
import React from 'react';
import { PropertyType as SrsPropertyType } from 'srs-middleware';
import { PropertyListSelector } from 'components/selectors/propertyListSelector';

/**
 * Custom renderer for the controls available to change the chart settings.
 *
 * Data Properties for this Widget:
 *   -- propertyList
 *   -- limit
 *
 * Chart Properties for this Widget:
 *
 * @param chartConfiguration
 * @param updateConfiguration
 * @returns {*}
 * @constructor
 */
export const TimelineGraphKnobs = ({ cardIndex, endpointQuery }) => {
  return (
    <Tabs>
      <Tab id="data" title="Data" panel={
        <React.Fragment>
          <PropertyListSelector
            cardIndex={cardIndex}
            itemIndex={0}
            types={[SrsPropertyType.Temporal]}
            label='1st Hierarchy Level'
            endpointQuery={endpointQuery}
            cy-test='first-hierarchy-dropdown-button'
          />
        </React.Fragment>
      } />
    </Tabs>
  );
};
